export default function selectJiraAreAssignableUsersLoading(state, { source }) {
  return state.integrations.thirdPartyData[source].assignableUsers.loading
}
